import { render, staticRenderFns } from "./horizen_1.vue?vue&type=template&id=1343a6e2&scoped=true&"
import script from "./horizen_1.vue?vue&type=script&lang=js&"
export * from "./horizen_1.vue?vue&type=script&lang=js&"
import style0 from "./horizen_1.vue?vue&type=style&index=0&id=1343a6e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1343a6e2",
  null
  
)

export default component.exports